import { render } from "./autoTextarea.vue?vue&type=template&id=3067b95a&ts=true"
import script from "./autoTextarea.vue?vue&type=script&lang=ts"
export * from "./autoTextarea.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__